import moment from "moment";
// import { isNumber } from "util";

interface IPadOptions {
    positions: number;
    symbol: string;
}

function padLeft(input: number | string, providedOptions: number): string {
    const parts = [];
    const options: IPadOptions = {
        positions: providedOptions,
        symbol: "0",
    };

    const stringified = String(input);
    const additions = options.positions - stringified.length;

    for (let x = 0; x < additions; x++) {
        parts.push("0");
    }

    parts.push(stringified);

    return parts.join("");
}

interface ICountdownOptions {
    zero?: string;
}

export default function formatCountdown(
    timestamp: number,
    providedOptions?: ICountdownOptions,
): string {
    if (!timestamp) {
        return "-";
    }

    const options: ICountdownOptions = providedOptions || {};

    const future = moment.unix(timestamp);
    const now = moment();

    const MINUTE_IN_SECONDS = 60;

    let allSeconds = future.diff(now, "seconds");

    if (allSeconds <= 0 && options.zero) {
        return options.zero;
    }

    const negative = allSeconds < 0;

    if (negative) {
        allSeconds *= -1;
    }

    const minutes = Math.floor(allSeconds / MINUTE_IN_SECONDS);
    const seconds = allSeconds % MINUTE_IN_SECONDS;

    const NUMBER_PADDING = 2;

    return `${negative ? "-" : ""}${minutes}:${padLeft(seconds, NUMBER_PADDING)}`;
}



// WEBPACK FOOTER //
// ./src/utils/formatCountdown.ts